const requestMethodTypes = {
    POST: 'POST',
    GET: 'GET',
};

export default requestMethodTypes;
